import React from 'react'

import { CabinMediaDrawerArrowRight } from './CabinMediaDrawerArrowRight'

export const CabinMediaDrawerArrowLeft: React.FC<React.SVGProps<SVGSVGElement>> = props => (
    <CabinMediaDrawerArrowRight
        {...props}
        style={{
            ...props.style,
            transform: 'scaleX(-1)',
        }}
    />
)

export default CabinMediaDrawerArrowLeft
